import { CircleExclamation, CircleXmark } from "@gravity-ui/icons";
import { Icon, Text } from "@gravity-ui/uikit";

import css from "./LogBlock.module.scss";

interface LogBlockProps {
  type: "warning" | "error";
  log?: string;
}

export const LogBlock = ({ type, log }: LogBlockProps) => {
  const color: Record<LogBlockProps["type"], string> = {
    warning: "var(--g-color-text-warning)",
    error: "var(--g-color-text-danger)",
  };

  const icon = {
    warning: CircleExclamation,
    error: CircleXmark,
  };

  return (
    <div
      className={css.logBlock}
      style={{
        color: color[type],
      }}
    >
      <Icon data={icon[type]} size={24} />
      <Text variant="subheader-1">{log}</Text>
    </div>
  );
};
